module.exports = function() {
  return new Worker(__webpack_public_path__ + "f7d59b7ad8e82e4ea8d3.worker.js");
};